import { render, staticRenderFns } from "./startups.vue?vue&type=template&id=7dbebba1&scoped=true&"
import script from "./startups.ts?vue&type=script&lang=ts&"
export * from "./startups.ts?vue&type=script&lang=ts&"
import style0 from "./startups.styl?vue&type=style&index=0&id=7dbebba1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbebba1",
  null
  
)

export default component.exports